// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__2MST6","buttons":"PendingPaymentAlert_buttons__220zy"};